import React, { useState } from 'react';
import './home.css';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../components/Common/Footer';
import { Helmet } from 'react-helmet';
import { Purple } from '../components/WorkshopPurple/Purple';
import { API } from '../types/api';
import { RegisterModal } from '../components/Modals/Register';

export const PurpleTemplate = ({
  page,
}: {
  page: API.Responses.WebinarDetails;
}) => {
  const [registerModalOpen, setRegisterModalOpen] = useState<boolean>(false);

  const onRegister = () => {
    setRegisterModalOpen(true);
  };

  const { name } = page.page;

  return (
    <div className="w-full text-black bg-white centerPage">
      <Helmet>
        <title>{name} | BigBang.Social</title>
        <meta name="description" content={name} />
      </Helmet>

      <Purple webinar={page} onRegister={onRegister} />
      <Footer />
      <RegisterModal
        show={registerModalOpen}
        setShow={setRegisterModalOpen}
        webinar={page}
      />
    </div>
  );
};
